import { cn } from "@gettactic/helpers/src/css/cn";
import React from "react";
import { FormControlWrapper } from "../FormControlWrapper";
import { splitFormControlWrapperProps } from "../FormControlWrapper/helpers";
import {
  TextEditorInputProps,
  TextEditorInputPropsWithFormControl
} from "./TextEditorInput.types";
import { TextEditor } from "./TextEditor";

export const TextEditorInputInput: React.FC<TextEditorInputProps> = (props) => {
  const { className, disabled, contentClassName, ...rest } = props;
  return (
    <div className={cn(className)}>
      <TextEditor
        {...rest}
        disabled={disabled}
        contentClassName={contentClassName}
      />
    </div>
  );
};

TextEditorInputInput.displayName = "TextEditorInputInput";

export const TextEditorInput = React.forwardRef<
  HTMLDivElement,
  TextEditorInputPropsWithFormControl
>((props, ref) => {
  const [wrapperProps, inputProps] = splitFormControlWrapperProps(props);

  return (
    <FormControlWrapper variant={"unstyled"} {...wrapperProps}>
      <div className={"w-full"} ref={ref}>
        <TextEditorInputInput {...inputProps} />
      </div>
    </FormControlWrapper>
  );
});

TextEditorInput.displayName = "TextEditorInput";
